<style src="./DiscountTag.scss" lang="scss"></style>
<script src="./DiscountTag.js"></script>

<template>
  <div class="discount-tag">
    <span>{{ name }}</span>
  </div>
</template>
